class ICoreThemeToggle {
    static storageKey = 'igx-theme';
    static defaultTheme = 'dark';

    html = document.documentElement;
    toggleButton = null;

    eventHandler = {};

    constructor(element) {
        this.toggleButton = element;

        if (!this.toggleButton) {
            return;
        }

        this.eventHandler = {
            click: this.onClick.bind(this),
        };

        this.#initEvents();
    }

    static isValidTheme(theme) {
        return theme === 'dark' || theme === 'light';
    }

    static setCookie(theme) {
        const maxAge = 365 * 24 * 60 * 60;
        document.cookie = `${ICoreThemeToggle.storageKey}=${encodeURIComponent(theme)};path=/;max-age=${maxAge};samesite=lax`;
    }

    static getCookie() {
        const match = document.cookie.match(new RegExp(`(?:^|; )${ICoreThemeToggle.storageKey}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : null;
    }

    static persistTheme(theme) {
        document.documentElement.setAttribute('data-theme', theme);

        try {
            localStorage.setItem(ICoreThemeToggle.storageKey, theme);
        } catch (e) {}

        ICoreThemeToggle.setCookie(theme);
    }

    static resolveTheme() {
        let fromStorage = null;

        try {
            fromStorage = localStorage.getItem(ICoreThemeToggle.storageKey);
        } catch (e) {}

        const fromCookie = ICoreThemeToggle.getCookie();
        const fromDom = document.documentElement.getAttribute('data-theme');
        const candidates = [fromStorage, fromCookie, fromDom];

        for (const theme of candidates) {
            if (ICoreThemeToggle.isValidTheme(theme)) {
                return theme;
            }
        }

        return ICoreThemeToggle.defaultTheme;
    }

    static applySavedTheme() {
        ICoreThemeToggle.persistTheme(ICoreThemeToggle.resolveTheme());
    }

    #initEvents() {
        this.toggleButton.addEventListener('click', this.eventHandler.click);
    }

    onClick() {
        const current = this.html.getAttribute('data-theme');
        const next = current === 'light' ? 'dark' : 'light';

        ICoreThemeToggle.persistTheme(next);
    }

    destroy() {
        this.toggleButton.removeEventListener('click', this.eventHandler.click);
    }
}

export default ICoreThemeToggle;
